import * as React from "react";
const DialogBackground = (props) => (
  <svg
    width={787}
    height={394}
    viewBox="0 0 787 394"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M582.181 63.3742C668.265 12.6151 786.403 0 786.403 0V188.015V291.204V336.678C786.403 336.678 778.92 359.414 768.035 372.532C755.386 387.776 725.858 393.519 725.858 393.519H587.761H391.841H0C0 393.519 187.542 373.841 285.201 326.743C412.128 265.529 462.141 134.155 582.181 63.3742Z"
      fill="url(#paint0_linear_214_1903)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_214_1903"
        x1={303.18}
        y1={62.3059}
        x2={726.382}
        y2={455.234}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#DFDFDF" />
        <stop offset={1} stopColor="#F1F1F1" />
      </linearGradient>
    </defs>
  </svg>
);
export default DialogBackground;
